// js-topMv-slik
jQuery(function ($) {
  $('.js-topMv-slik').slick({
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 6000,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
  });
});

// js-topSeminar-slik
jQuery(function ($) {
  $('.js-topSeminar-slik').slick({
    arrows: true,
    dots: true,
    asNavFor: null,
    appendArrows: $('.js-slikItem'),
    appendDots: $('.js-slikItem'),
    centerMode: true,
    centerPadding: '12%',
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          centerPadding: '16%',
          slidesToShow: 1,
        },
      },
    ],
  });
});

// js-topWorks-slik
jQuery(function ($) {
  $('.js-topWorks-slik').slick({
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 2000,
    arrows: true,
    dots: true,
    asNavFor: null,
    appendArrows: $('.js-slikItem02'),
    appendDots: $('.js-slikItem02'),
    centerMode: false,
    slidesToShow: 4,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  });
});
